import { render, staticRenderFns } from "./shopPartnerDeclareMonthInfoList.vue?vue&type=template&id=010ab8b3&scoped=true"
import script from "./shopPartnerDeclareMonthInfoList.vue?vue&type=script&lang=ts"
export * from "./shopPartnerDeclareMonthInfoList.vue?vue&type=script&lang=ts"
import style0 from "./shopPartnerDeclareMonthInfoList.vue?vue&type=style&index=0&id=010ab8b3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010ab8b3",
  null
  
)

export default component.exports